import React from "react";
import CompanyLogo from "../../../../assets/img/logos/dicelogoTransparent_01.png";
import CompanyLogo02 from "../../../../assets/img/logos/original.png";
import QrCodes from "../appComponents/QrCodes";
const UserTable = (props) => {
  // Fetch the Current Date
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  function numberWithCommas(x) {
    if (!x) {
      x = 0;
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const myStyle = {
    backgroundImage: `url(${CompanyLogo02})`,
    height: "100%",
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "Block",
    position: "absolute",
    zIndex: "20",
  };
  return (
    <>
      <div className="row">
        <table width="150%" border="0" cellspacing="0" cellpadding="50">
          <tr>
            <td>
              {props.general.stamp && <div style={myStyle}></div>}
              <table
                width="100%"
                border="0"
                align="left"
                cellpadding="6"
                cellspacing="0"
              >
                <tr>
                  <td colspan="3" align="left" valign="top" bgcolor="#FFFFFF">
                    <label></label>
                    <table
                      width="100%"
                      border="0"
                      cellspacing="1"
                      cellpadding="5"
                    >
                      <tr>
                        <td width="20%" height="83">
                          <img
                            loading="lazy"
                            decoding="async"
                            name=""
                            src={CompanyLogo}
                            width="100"
                            height="100"
                            alt={CompanyLogo || "Image"}
                          />
                        </td>
                        <td width="60%">
                          <table
                            width="100%"
                            border="0"
                            align="center"
                            cellpadding="2"
                            cellspacing="0"
                          >
                            <tr>
                              <td
                                width="100%"
                                align="center"
                                valign="top"
                                font
                                color="#FF0000"
                              >
                                <font size="4">
                                  <b>WEBDYNAMO TIME ATTENDANCE SYSTEM </b>
                                  <br />
                                </font>
                                FROM CVIEWSOFT
                              </td>
                            </tr>
                            <tr>
                              <td align="center" valign="top">
                                <b>Staff Data</b>
                              </td>
                            </tr>
                            <tr>
                              <td height="19" align="center" valign="top">
                                <b>Generated:</b> {getCurrentDate()}
                              </td>
                            </tr>
                            <tr>
                              <td height="8" align="center" valign="top">
                                <hr />
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td width="20%" align="right" valign="top">
                          <table
                            width="100%"
                            border="0"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tr>
                              <td>
                                <table
                                  align="right"
                                  width="100%"
                                  border="0"
                                  cellspacing="0"
                                  cellpadding="1"
                                >
                                  <tr>
                                    <td
                                      width="40%"
                                      align="right"
                                      valign="middle"
                                    >
                                      <b>Slip NO.</b>
                                      {props.general.referenceNo && (
                                        <div
                                          style={{
                                            marginLeft: "0px",
                                            paddingTop: "0px",
                                            paddingRight: "60px",
                                            display: "Block",
                                            position: "absolute",
                                            zIndex: "10",
                                          }}
                                        >
                                          <QrCodes
                                            addrurl={props.general.referenceNo}
                                            qrcodeSize={"70%"}
                                          />
                                        </div>
                                      )}
                                    </td>
                                    <td width="60%" align="right" valign="top">
                                      00000000
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td></td>
                </tr>

                <tr>
                  <tr>
                    <td height="40"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tr>

                <tr>
                  <table
                    className="table table-hover"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        {[
                          { column: "Employee", width: "20%" },
                          { column: "Acct. Detail", width: "20%" },
                          { column: "Salary", width: "10%" },
                          { column: "Shift", width: "20%" },
                          { column: "Location/ Depart", width: "20%" },
                          { column: "Contact", width: "20%" },
                        ].map((items, index) => (
                          <>
                            <th
                              key={index}
                              scope="col"
                              style={{ width: items.width }}
                            >
                              {items.column}
                            </th>
                          </>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {props.itemId.map((allRecord, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {allRecord.name}
                              <br />
                              <em style={{ color: "red" }}>
                                Staff No.: {allRecord.fileNumber}
                              </em>
                            </td>
                            <td>
                              {allRecord.bank}
                              <br />
                              <em style={{ color: "red" }}>
                                Acct No.: {allRecord.accountNo}
                              </em>
                            </td>
                            <td>#{numberWithCommas(allRecord.salary)}</td>
                            <td>{allRecord.shift}</td>
                            <td>
                              {allRecord.location}
                              <br />
                              <em style={{ color: "red" }}>
                                Depart.: {allRecord.department}
                              </em>
                            </td>
                            <td>
                              {allRecord.email}
                              <br />
                              <em style={{ color: "red" }}>
                                Phone.: {allRecord.phone}
                              </em>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default UserTable;
